import { render, staticRenderFns } from "./createShare.vue?vue&type=template&id=f3a1a8e0&scoped=true&"
import script from "./createShare.vue?vue&type=script&lang=js&"
export * from "./createShare.vue?vue&type=script&lang=js&"
import style0 from "./createShare.vue?vue&type=style&index=0&id=f3a1a8e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a1a8e0",
  null
  
)

export default component.exports